import '../../utils/index.mjs';
import Card from './src/card.mjs';
export { cardProps } from './src/card2.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElCard = withInstall(Card);

export { ElCard, ElCard as default };
//# sourceMappingURL=index.mjs.map
